import { FC } from "react";
import { Page } from "../../../Components/Page";
import { Button, Loader, Table, Avatar } from "@mantine/core";
import { Link } from "react-router-dom";
import { components } from "../../../openapi/generated-types";
import { useTeamList } from "../../../hooks/useTeamList.ts";

interface TableRowProps {
  team: components["schemas"]["Team"];
}

const TableRow: FC<TableRowProps> = (props) => {
  const { team } = props;

  return (
    <Table.Tr>
      <Table.Td>
        <Avatar src={team.logoFilePath}>{team.shortName}</Avatar>
      </Table.Td>
      <Table.Td style={{ whiteSpace: "nowrap" }}>{team.name}</Table.Td>
      <Table.Td style={{ whiteSpace: "nowrap" }}>{team.mediumName}</Table.Td>
      <Table.Td>{team.shortName}</Table.Td>
      <Table.Td style={{ whiteSpace: "nowrap" }}>{team.sponsor?.name}</Table.Td>
    </Table.Tr>
  );
};

export const TeamOverview: FC = () => {
  const teamData = useTeamList();

  if (!teamData.isSuccess) {
    return <Loader />;
  }

  return (
    <Page
      title="Mannschaften"
      action={
        <Button component={Link} to="new">
          Neue Mannschaft
        </Button>
      }
    >
      <Table.ScrollContainer minWidth={500}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th w="1%">Logo</Table.Th>
              <Table.Th w="1%">Name</Table.Th>
              <Table.Th w="1%">Kurzer Name</Table.Th>
              <Table.Th w="1%">Kurzform</Table.Th>
              <Table.Th>Sponsor</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {teamData.data.teams.map((t) => (
              <TableRow key={t.id} team={t} />
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Page>
  );
};
